


















































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Locales } from "@/i18n/locales";

@Component
export default class AlertComponent extends Vue {
  @Prop() alert!: boolean;
  @Prop() title!: boolean;
  @Prop() text!: string;
  @Prop() type!: string;
  @Prop() timeout: number;
  @Prop() okButtonTitle!: string;
  @Prop() cancelButtonTitle!: string;

  mounted() {}

  onOK() {
    this.$emit("okClick", this.alert);
  }

  onCancel() {
    this.$emit("cancelClick", this.alert);
    this.alert = false;
  }
}
